/** "Field 12", "Polygon 3", and "Block 2" are just the number. Other names stay. */
const GENERIC_POLYGON_LABEL = /^(?:field|polygon|block)\s*#?\s*(\d+)\s*$/i;

export function shortPolygonLabel(value: unknown, index: number): string {
  const text = value == null ? '' : String(value).trim();
  if (!text) return String(index + 1);
  const generic = text.match(GENERIC_POLYGON_LABEL);
  if (generic) return generic[1];
  return text;
}

/** Labels for uploaded / delineated polygon features. */
export function polygonFeatureLabel(feature: unknown, index: number): string {
  const raw =
    feature && typeof feature === 'object' && 'properties' in feature
      ? (feature as { properties?: unknown }).properties
      : null;
  const props = raw && typeof raw === 'object' ? (raw as Record<string, unknown>) : {};
  const keys = ['name', 'NAME', 'Name', 'farm_name', 'field_name', 'NAM'];
  for (const key of keys) {
    const value = props[key];
    if (value != null && String(value).trim()) return shortPolygonLabel(value, index);
  }
  return String(index + 1);
}
